{
  "destinationSearch": {
    "calendarButton": "#View dates#"
  },
  "bookingSearch": {
    "errors": {
      "noResults": {
        "noFlightsFound": "Sorry, we couldn't find any flights",
        "noFlightsAvailable": "Sorry, there are no flights available"
      },
      "actions": {
        "reloadPage": "Reload this page",
        "toFrontPage": "Go to front page"
      }
    }
  },
  "serviceForms": {
    "refundsCompensations": {
      "continue": "Continue",
      "newCase": "Create new case",
      "viewCase": "View existing cases",
      "infoAccordion": [
        {
          "title": "Eligible refund and compensation cases",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Documents needed for submitting a claim",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Gift voucher benefits",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        }
      ]
    },
    "specialAssistanceWizard": {
      "infoAccordion": [
        {
          "title": "Accordion title 1",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Accordion title 2",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Accordion title 3",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        }
      ]
    },
    "refundForm": {
      "refundReason": {
        "orderNotDelivered": "Finnair cancelled my flight due to flight disruption or didn't deliver my order"
      },
      "retailPaymentDetailsNote": "We will need your bank details for the refund. Please select online bank option below."
    },
    "fields": {
      "preorderBagNumber": {
        "label": " Preorder Bag Number",
        "placeholder": "E.g. 6291015"
      }
    }
  },
  "ticketSelection": {
    "travelClassAlternative": "We could not find any flights with your selected travel class, so here are some other alternatives."
  },
  "indiaRedirectNotification": "Hi! We redirected you to our international site from the Indian country site, which is temporarily closed for enhancements. You can book flights and use our services on this site as you would on the Indian one. We are sorry for any inconvenience.",
  "chatUserForm": {
    "intro": "We kindly ask you to fill in these details to assist you better and maintain good service quality.",
    "firstName": {
      "label": "First name",
      "pattern": "Please enter a valid name",
      "maxlength": "Maximum length is 30 characters",
      "required": "First name is required"
    },
    "lastName": {
      "label": "Family name",
      "pattern": "Please enter a valid name",
      "maxlength": "Maximum length is 30 characters",
      "required": "Family name is required"
    },
    "emailAddress": {
      "label": "Email address",
      "pattern": "Please enter a valid email address",
      "required": "Email address is required"
    },
    "bookingRefQ": {
      "noBookingReference": "No",
      "yesBookingReference": "Yes",
      "label": "Is your question related to an existing booking?",
      "required": "\"Is your question related to an existing booking?\" is required"
    },
    "bookingReference": {
      "label": "Booking reference",
      "placeholder": "E.g. Y2KP3D",
      "maxlength": "Maximum length is 6 characters",
      "pattern": "The booking reference should have 6 characters, for example Y2KP3D. It cannot include 1, 0 or special characters.",
      "required": "Booking reference is required"
    },
    "submitText": "Start the chat"
  },
  "blueWingsSEO": {
    "bluewingTitle": "Blue Wings stories",
    "articlePlural": "{{count}} articles",
    "articleSingular": "{{count}} article",
    "tags": {
      "activeHolidays": "Active holidays",
      "airportAndFlights": "Airport & Flights",
      "autumn": "Autumn",
      "baggage": "Baggage",
      "beachHolidays": "Beach holidays",
      "booking&Payments": "Bookings & Payments",
      "businessTravel": "Business travel",
      "check-inAndBoarding": "Check-in & Boarding",
      "cityBreaks": "City breaks",
      "cross-countryJourneys": "Cross-country journeys",
      "culinaryTrips": "Culinary Trips",
      "cultureAndEvents": "Culture & events",
      "customerService": "Customer service",
      "destinations": "Destinations",
      "digitalServices": "Digital Services",
      "entertainment&InternetAccess": "Entertainment & Internet access",
      "familyTravel": "Family travel",
      "finnairEmployees": "Finnair employees",
      "finnairLounges": "Finnair lounges",
      "finnairPlus": "Finnair Plus",
      "finnairStories": "Finnair Stories",
      "fleet": "Fleet",
      "groupTravel": "Group travel",
      "health&MedicalIssues": "Health & Medical issues",
      "hiddenGems": "Hidden gems",
      "investorRelationsBlog": "Investors",
      "lifestyle": "Lifestyle",
      "nordicKitchen": "Nordic Kitchen",
      "off-seasonTravel": "Off-season travel",
      "outdoorAdventures": "Outdoor adventures",
      "pets": "Pets",
      "santa'sOfficialAirline": "Santa's official airline",
      "santasOfficialAirline": "Santa's official airline",
      "seasonalDestination": "Seasonal desatination",
      "seasonality": "Seasonality",
      "seats&TravelClasses": "Seats & Travel classes",
      "smoothTravel": "Smooth travel",
      "soloTravel": "Solo travel",
      "spring": "Spring",
      "summer": "Summer",
      "sustainability": "Sustainability",
      "travelExperience": "Travel Experience",
      "travelPreparations": "Travel preperations",
      "travelTips": "Travel tips",
      "winter": "Winter",
      "worldOfFinnair": "World of Finnair",
      "yourFinnairGuide": "Your Finnair Guide"
    }
  }
}
